<template>
  <div class="container">
    <input placeholder="姓名"></input>
    <input placeholder="身份证号"></input>

    <div style="height: 30px;font-size: 18px" @click="queryScore">成绩查询</div>

    <div style="height: 30px;font-size: 18px;margin-top: 20px" @click="queryDelivery">快递信息查询</div>
  </div>
</template>

<script>
import InfoList from '../../components/InfoList.vue'

export default {
  name: 'SignUpInfo',
  components: {InfoList},
  data() {
    return {}
  },
  created() {
  },
  activated() {
  },
  methods: {
    queryScore() {
      this.$router.push('/MyScore?orderId=')
    },
    queryDelivery() {
      this.$router.push('/MyDelivery?orderId=')
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100vh;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
  padding-bottom: 50px;

  .top-search-box {
    flex-shrink: 0;

    .t1 {
      display: flex;
      align-items: center;
      background-color: #fff;

      .shaixuan {
        flex-shrink: 0;
        padding: 0 15px 0 10px;
        font-size: 20px;
      }
    }

    .t1 /deep/ .van-search {
      flex: 1 1 auto;
    }
  }

  .top-search-box /deep/ .van-search__action {
    padding: 0 15px;
  }
}

/deep/ .van-dropdown-menu {
  border-bottom: 1px solid #f1f1f1;
}

/deep/ .van-dropdown-menu__bar {
  box-shadow: none;
}

.sxBox {
  display: flex;
  flex-direction: column;
  height: 100%;

  .sxTitle {
    font-size: 16px;
    flex-shrink: 0;
    padding: 15px;
  }

  .sxContainer {
    flex: 1 1 auto;
    overflow-y: auto;

    .title {
      font-size: 14px;
      color: #333333;
      padding: 15px;
    }

    .xiang {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      padding: 10px;

      span {
        width: 30%;
        font-size: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 36px;
        border: 1px solid #f1f1f1;
        border-radius: 3px;
        margin-bottom: 6px;
        margin-right: 5px;
      }

      span.active {
        color: #ff6400;
        border-color: #ff6400;
      }
    }
  }

  .sxFooter {
    flex-shrink: 0;
    display: flex;

    button {
      flex: 1;
      border: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/routerPages/info/SignUpInfo.vue